import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const NukaContainer = styled.div<{ count: number, widthCard: number }>`
    width: calc(${p => p.count * p.widthCard}px);
    @media ((max-width: ${wideBreakpoints.laptop}) and (min-width: ${wideBreakpoints.tablet})) {
        margin-left: -15px;
    }
`;
